import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetch, fetchLocalAgent } from "../../actions";
import { LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import { useFetch } from "../../components/Hooks/Conexao";
import { BtnCancelar, BtnPadrao, BtnSair } from "../../components/Buttons";
import useTotais from "../../components/Hooks/useTotais";
import Pagamento from "../Pagamento/Pagamento";
import useSavePagamentos from "../../components/Hooks/useSavePagamentos";
import { formatarPagamentos } from "../../Utils/utils";
import ErroModal from "../../components/ErroModal";
import Porcentagem from "../../Utils/Porcentagem";
import Mensagens from "../../components/Mensagens";
import { imprimirRetorno } from "../../Utils/impressaoUtils";

const INITIAL_VALORES_EXTRAS = { acrescimo: 0, acrescimoPerc: 0, descontoVenda: 0, descontoVendaPerc: 0 };

function ModalSinalPreVenda({ id, onOk, onCancel, ...props }) {
  const [pg, setPg] = useState([]);
  const [valoresExtras, setValoresExtras] = useState(INITIAL_VALORES_EXTRAS);

  const [preVenda, listar, loading, setPreVenda] = useFetch(() => props.fetch().post(`prevenda/recuperar/${id}`, {}), {}, {}, res => {

    let itensVenda = [...res.produtos, ...res.servicos.map(x => ({ ...x, isServico: true }))].map(x => ({ ...x, qtd: !!x.qtdPaga ? x.qtdPaga : x.qtd, descPorc: Porcentagem.obter(x.desconto, x.valorTotal + x.desconto) }));
    let valExtras = { descontoVendaPerc: 0, acrescimoPerc: 0, descontoVenda: res.descontoVenda || 0, acrescimo: res.acrescimo || 0, valorFrete: res.valorFrete || 0 };
    setValoresExtras(valExtras);
    let liquido = totais.calcularLiquido(itensVenda, valExtras);
    const pgSinal = (res?.pagamentos?.filter(x => x.isSinal) || []);
    setPg([...pgSinal, { modalidadeId: null, recebido: liquido - pgSinal.reduce((a, b) => a + b.recebido, 0) }]);

    setPreVenda({ ...res, itensVenda });
  });

  const totais = useTotais(preVenda?.itensVenda, pg, valoresExtras);

  const [erroFinalizacao, setErroFinalizacao] = useState();
  const [salvar, salvando, processandoPagamentos, abortar, abortando] = useSavePagamentos("/prevenda/adicionarsinal", { ...preVenda, pagamentos: formatarPagamentos(pg.filter(x => !x.isSinal), totais.troco), valorTotal: totais.liquido, descontoProduto: totais.desconto, troco: totais.troco, ...totais }, ret => { onOk(); Mensagens.showSucesso("Sinal adicionado com sucesso!"); imprimirRetorno(props.fetchLocalAgent, ret); }, props.fetch, erros => setErroFinalizacao({ title: "Erro ao processar o pagamento", erros }), erro => setErroFinalizacao({ title: "Erro ao processar a venda", erros: [erro] }));

  useEffect(() => {
    if (!!id)
      listar();
  }, [id]);

  return <>
    <ModalPadrao title="Adicionar sinal" width={900} visible={!!id} onCancel={onCancel} footer={<>
      <BtnPadrao disabled={pg.find(x => x.modalidadeId == null || x.modalidadeId <= 0)} onClick={() => salvar()} loading={salvando}>Finalizar</BtnPadrao>
      {processandoPagamentos ? <BtnCancelar loading={abortando} onClick={() => abortar()} showConfirm /> : <BtnSair disabled={salvando} onClick={onCancel} />}
    </>}>
      <LoadingContainerPadrao loading={loading || salvando} style={{ minHeight: 250 }}>
        <Pagamento totais={totais} pg={pg} setPg={setPg} tipo="sinal" tabIndex={1} />
        {totais.totalSinal}
      </LoadingContainerPadrao>
    </ModalPadrao>


    <ErroModal title={erroFinalizacao?.title} visible={!!erroFinalizacao} onCancel={() => setErroFinalizacao(null)} >
      {erroFinalizacao?.erros?.map(x => <p key={x?.toString()} style={{ marginTop: 20, textAlign: "center" }}>{x?.toString()}</p>)}
    </ErroModal>
  </>;
}

export default connect(null, { fetch, fetchLocalAgent })(ModalSinalPreVenda);